/* ==========================================================================
   ANTI-PIGMENTATION TRIO — page behaviour.
   Independent IIFEs; each one no-ops if its markup is absent, so the file is
   safe to load on any page.
   ========================================================================== */

/* --- 1. scroll reveal ------------------------------------------------- */
(function () {
  'use strict';
  var els = document.querySelectorAll('.ptrio__rv');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();

/* --- 2. scroll-linked motion: hero drift and the pathway fill --------- */
(function () {
  'use strict';
  var frame = document.querySelector('[data-ptrio-parallax]');
  var path = document.querySelector('[data-ptrio-path]');
  if (!frame && !path) return;

  var steps = path ? [].slice.call(path.querySelectorAll('[data-ptrio-step]')) : [];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce) {
    if (path) path.style.setProperty('--ptrio-p', 1);
    steps.forEach(function (s) { s.classList.add('is-on'); });
    return;
  }

  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;

    if (frame) {
      var fr = frame.getBoundingClientRect();
      if (fr.bottom > 0 && fr.top < vh) {
        var shift = Math.min(1, Math.max(0, -fr.top / fr.height + 0.15));
        frame.style.setProperty('--ptrio-shift', shift.toFixed(3));
      }
    }

    if (path) {
      var pr = path.getBoundingClientRect();
      /* the fill's leading edge follows a line 62% of the way down the screen */
      var reach = vh * 0.62 - pr.top;
      var p = Math.min(1, Math.max(0, reach / pr.height));
      path.style.setProperty('--ptrio-p', p.toFixed(4));
      steps.forEach(function (step) {
        step.classList.toggle('is-on', step.offsetTop <= reach);
      });
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* --- 3. packshot tilt (mouse only) ------------------------------------ */
(function () {
  'use strict';
  var stages = document.querySelectorAll('[data-ptrio-tilt]');
  if (!stages.length) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  [].forEach.call(stages, function (stage) {
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      stage.style.setProperty('--ptrio-ry', (x * 7).toFixed(2) + 'deg');
      stage.style.setProperty('--ptrio-rx', (y * -7).toFixed(2) + 'deg');
    });
    stage.addEventListener('pointerleave', function () {
      stage.style.setProperty('--ptrio-ry', '0deg');
      stage.style.setProperty('--ptrio-rx', '0deg');
    });
  });
})();
